import React from 'react';
import { isBlank, isPresent } from 'utils/helperMethods';
import { Box, Button, Typography, Link } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Icon from 'sharedComponents/Icon';
import BidPresenter from 'presenters/BidPresenter';
import LoanOfficerPresenter from 'presenters/LoanOfficerPresenter';

import useStyles from './useStyles';

const LoanTermsInfo = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { bid, loanOfficer } = props;

  const isApplicationUrlPresent = !isBlank(BidPresenter.loanOfficerApplicationUrl(bid));
  const isLoanOfficerPresent = isPresent(loanOfficer);

  const loanOfficerName = isLoanOfficerPresent
    ? LoanOfficerPresenter.fullName(loanOfficer)
    : t('models.App.userTypes.loanOfficer');

  const isOutsideGuidelines = BidPresenter.isOutsideGuidelines(bid);

  if (isOutsideGuidelines)
    return (
      <Box>
        <Typography className={classes.bidInfoText}>
          {t('components.LoanOfficerCard.outsideGuidelines', { name: loanOfficerName.split(' ')[0] })}
        </Typography>
      </Box>
    );

  return (
    <Box className={classes.container}>
      <Box className={classes.bidBadge}>
        <Box display="flex" flexDirection="column" width={120}>
          <Typography variant="body2" color="secondary">
            {t('components.LoanTermsInfo.totalCost')}
          </Typography>
          <Typography variant="h1" className={classes.bidInfoText}>
            {BidPresenter.getTotalCost(bid)}
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" width={90}>
          <Typography variant="body2" color="secondary">
            {t('components.LoanTermsInfo.apr')}
          </Typography>
          <Typography variant="h1" className={classes.bidInfoText}>
            {BidPresenter.getApr(bid)}
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" width={90}>
          <Typography variant="body2" color="secondary">
            {t('components.LoanTermsInfo.interestRate')}
          </Typography>
          <Typography variant="h1" className={classes.bidInfoText}>
            {BidPresenter.getInterestRate(bid)}
          </Typography>
        </Box>
      </Box>
      {isApplicationUrlPresent && (
        <Box>
          <Link target="_blank" href={BidPresenter.loanOfficerApplicationUrl(bid)}>
            <Button className={classes.applyButton} startIcon={<Icon name="done" className={classes.icon} />}>
              {t('components.LoanTermsInfo.applyButton')}
            </Button>
          </Link>
        </Box>
      )}
      <Box mt={2} className={classes.divider} />
      <Box display="flex" justifyContent="space-between" my={3}>
        <Box width="80%" textOverflow="ellipsis">
          <Typography variant="subtitle1" color="secondary">
            {t('components.LoanTermsInfo.monthlyPrInMiPayment')}
          </Typography>
        </Box>
        <Box width="20%" textOverflow="ellipsis" display="flex" justifyContent="flex-end">
          <Typography variant="subtitle1" color="secondary">
            {BidPresenter.monthlyPrInMi(bid)}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.divider} />
      <Box display="flex" justifyContent="space-between" my={3}>
        <Box width="80%" textOverflow="ellipsis">
          <Typography variant="subtitle1" color="secondary">
            {t('components.LoanTermsInfo.monthlyTaxesInsurancePayment')}
          </Typography>
        </Box>
        <Box width="20%" textOverflow="ellipsis" display="flex" justifyContent="flex-end">
          <Typography variant="subtitle1" color="secondary">
            {BidPresenter.monthlyEstimatedTaxesInsurance(bid)}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.divider} />
      <Box display="flex" justifyContent="space-between" my={3}>
        <Box width="80%" textOverflow="ellipsis">
          <Typography variant="subtitle1" color="secondary">
            {t('components.LoanTermsInfo.monthlyTotalPayment')}
          </Typography>
        </Box>
        <Box width="20%" textOverflow="ellipsis" display="flex" justifyContent="flex-end">
          <Typography variant="subtitle1" color="secondary">
            {BidPresenter.totalMonthlyPayment(bid)}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.divider} />
      <Box display="flex" justifyContent="space-between" my={3}>
        <Box width="80%" textOverflow="ellipsis">
          <Typography variant="subtitle1" color="secondary">
            {t('components.LoanTermsInfo.originationCharges')}
          </Typography>
        </Box>
        <Box width="20%" textOverflow="ellipsis" display="flex" justifyContent="flex-end">
          <Typography variant="subtitle1" color="secondary">
            {BidPresenter.originationCharges(bid)}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.divider} />
      <Box className={classes.notes}>
        <Typography variant="subtitle1" color="secondary">
          {BidPresenter.notes(bid)}
        </Typography>
      </Box>
    </Box>
  );
};

LoanTermsInfo.propTypes = {
  bid: BidPresenter.shape().isRequired,
};

export default LoanTermsInfo;



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanTermsInfo/LoanTermsInfo.js